import React from "react";
import { Button } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiTrashCanOutline } from "@mdi/js";
import CardShell from "./CardShell";

const DeleteJobCard = ({ onDelete }) => (
  <CardShell
    icon={
      <Icon
        path={mdiTrashCanOutline}
        size={0.7}
        className="jd-card-icon jd-danger-icon"
      />
    }
    title="Delete Job"
    className="jd-card--danger"
    headerRight={
      <Button variant="outline-danger" size="sm" onClick={onDelete}>
        Delete Job
      </Button>
    }
  >
    <div className="jd-subtle">
      Permanently remove this job and all associated data. This action cannot be
      undone.
    </div>
  </CardShell>
);

export default DeleteJobCard;
